import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import Banner from '../partials/Banner';
import Page from './account/page';
import TwoFactorAuthentication from '../components/account/two-factor-authentication';
import { logAuditUI } from '../utils/auditLogger';

function UsersAbout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const selectedUser = location.state?.item;

    useEffect(() => {
        if (selectedUser) {
            logAuditUI({
                actionType: 'OPEN_FORM',
                module: 'Utilizatori',
                entityType: 'user',
                entityId: selectedUser.user_id,
                entityName: selectedUser.user_name_surname || selectedUser.login,
                description: `A deschis pagina de profil a utilizatorului: ${selectedUser.user_name_surname || selectedUser.login || selectedUser.user_id}`,
            });
        }
    }, [selectedUser]);

    let isAdmin = false;

    try {
        const token = localStorage.getItem('jwtToken');
        isAdmin = token ? jwtDecode(token).role === 'Admin' : false;
    } catch {
        isAdmin = false;
    }

    const canManageTwoFactor = isAdmin
        && location.state?.fromUserManagement === true
        && Number.isInteger(selectedUser?.user_id);

    const isSelfProfile = !selectedUser || selectedUser.user_id === undefined;
    const profileTitle = isSelfProfile ? "Contul meu" : "Contul utilizatorului";
    const breadcrumbSection = location.state?.fromUserManagement ? "Utilizatori" : "Cont";
    const breadcrumbPage = isSelfProfile ? "Profilul meu" : (selectedUser?.user_name_surname || selectedUser?.login || "Profil");

    return (
        <div className="flex h-screen overflow-hidden bg-[#F6F7FB] dark:bg-gray-900">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-8 lg:px-8 py-6 pb-9 w-full">
                        {/* Page Header */}
                        <div className="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                            <div>
                                <div className="flex items-center gap-1.5 text-xs font-medium text-[#98A1B2] dark:text-gray-400 mb-1">
                                    <span>{breadcrumbSection}</span>
                                    <span>›</span>
                                    <span className="text-[#697386] dark:text-gray-300 font-semibold">{breadcrumbPage}</span>
                                </div>
                                <h1 className="text-[24px] sm:text-[26px] font-bold text-[#172033] dark:text-gray-100 leading-tight tracking-[-0.02em]">
                                    {profileTitle}
                                </h1>
                                <p className="text-xs text-[#7B8496] dark:text-gray-400 mt-0.5">
                                    Gestionează informațiile profilului și accesul în platformă.
                                </p>
                            </div>
                            {canManageTwoFactor && (
                                <div className="flex items-center gap-3 self-start sm:self-center">
                                    <TwoFactorAuthentication compact targetUserId={selectedUser.user_id} />
                                </div>
                            )}
                        </div>
                        <Page />
                    </div>
                </main>
                <Banner />
            </div>
        </div>
    );
}

export default UsersAbout;
